










































import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {redirectUri} from '@/constants/urls';
import {Button, Paragraph} from '@/components/Base';
import {Box, HeroImageWrapper} from '@/components/Shared';
import {legalText} from '@/static/legalText';
import {getKeycloak} from "@/components/auth/keycloak";

@Component({
  components: {
    Box,
    Button,
    Paragraph,
    HeroImageWrapper,
  },
})
export default class Login extends Vue {
  @Getter public isLegalMessageDisplayed: boolean;
  public legalText: string = legalText;

  public handleLoginClick() {
    getKeycloak().login(redirectUri());
  }

  public handleShowLegalClick() {
    this.$store.dispatch('toggleLegalMessage', true);
  }

  public handleRegisterClick() {
    getKeycloak().register(redirectUri());
  }

  public handleCancelClick() {
    this.$store.dispatch('toggleLegalMessage', false);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Login/Login.vue